import script from "./AdminQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminQuestions.vue?vue&type=script&setup=true&lang=js"

import "./AdminQuestions.vue?vue&type=style&index=0&id=72ba48a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ba48a2"]])

export default __exports__